import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect } from "react";
import BaseCard from "../../components/card/BaseCard";
import BaseTable from "../../components/BaseTable";
import { Table, type TableProps } from "antd";
import { $api, type components } from "../../helper";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function ManagementPage() {
  const { setDashboardName } = useStore(useDashboardName);
  const { data, isLoading } = $api.useQuery("get", "/site-api/v1/page/");
  useEffect(() => {
    setDashboardName("مدیریت صفحات");
  }, []);

  const columns: TableProps<components["schemas"]["SitePageItem"]>["columns"] =
    [
      {
        title: "#",
        dataIndex: "key",
        key: "key",
        render: (_, record, index) => <span>{index + 1}</span>,
      },
      {
        title: "نام صفحه",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "عملیات",
        key: "action",
        render: (_, record) => (
          <div className="flex">
            {/* <ButtonLinkIcon
              to={`/management-page/${record.u_id}`}
              icon="solar:pen-new-square-linear"
              className="text-primary-500!"
            /> */}
            <ButtonLinkIconSvg
              icon={<PenSquare />}
              to={`/management-page/${record.u_id}`}
              className="text-primary-500!"
            />
          </div>
        ),
      },
    ];
  return (
    <div className="flex flex-col gap-6">
      <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
        <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
          <Table<components["schemas"]["SitePageItem"]>
            loading={isLoading}
            className="col-span-1!"
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={data?.data}
          />
        </BaseTable>
      </BaseCard>
    </div>
  );
}
